
import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

interface ProjectTracking {
  id: string;
  organizationId: string;
  trackingType: string;
  statusId: string;
  phaseId: string | null;
  startDate: string | null;
  endDate: string | null;
  changedBy: string;
  notes: string;
  isCurrent: boolean;
  eventSource: string;
  reportDate: string;
  progressPercent: number;
}

export const addProjectTracking = createAsyncThunk('Project/addProjectTracking', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectTracking', item);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

const initialState: {
  trackingRecords: ProjectTracking[];
  previousTrackingRecords: ProjectTracking[];
  loading: boolean;
  error: any | null;
} = {
  trackingRecords: [],
  previousTrackingRecords: [],
  loading: false,
  error: null,
};

const projectTrackingSlice = createSlice({
  name: 'ProjectTracking',
  initialState,
  reducers: {
    updateTrackingInList: (state, action: PayloadAction<{ trackingId: string; updates: Partial<ProjectTracking> }>) => {
      const { trackingId, updates } = action.payload;
      const idx = state.trackingRecords.findIndex(t => String(t.id) === String(trackingId));
      if (idx !== -1) {
        state.trackingRecords[idx] = { ...state.trackingRecords[idx], ...updates };
      }
    },
    rollbackTracking: state => {
      state.trackingRecords = state.previousTrackingRecords;
    }
  },
  extraReducers(builder) {
    // يمكن إضافة extra reducers للحالات الأخرى إذا كانت هناك APIs للحصول على البيانات
  }
});

export const { updateTrackingInList, rollbackTracking } = projectTrackingSlice.actions;
export default projectTrackingSlice.reducer;